export default [
  {
    id: 'downloadHistory',
    title: 'Download history',
    icon: 'mdi-download',
    action: 'downloadHistory',
    _enabled: true
  },
  {
    id: 'downloadLogs',
    title: 'Download notifications',
    icon: 'mdi-download',
    action: 'downloadLogs',
    _enabled: true
  },
  {
    id: 'changeSchema',
    action: 'changeSchema',
    title: 'Change schema',
    icon: 'mdi-card-bulleted',
    _enabled: true
  },
  {
    id: 'massiveDisable',
    action: 'massiveDisable',
    title: 'Disable',
    icon: 'mdi-cancel',
    _enabled: true
  },
  {
    id: 'massiveEnable',
    action: 'massiveEnable',
    title: 'Enable',
    icon: 'mdi-power-off',
    _enabled: true
  },
  {
    id: 'massiveMute',
    action: 'massiveMute',
    title: 'Mute',
    icon: 'mdi-volume-off',
    _enabled: false
  },
  {
    id: 'massiveUnmute',
    action: 'massiveUnmute',
    title: 'Unmute',
    icon: 'mdi-volume-high',
    _enabled: false
  },
  {
    id: 'delete',
    title: 'Delete',
    icon: 'mdi-delete',
    action: 'delete',
    _enabled: true
  }
];
